  //import 'script-loader!./init.js'
  import './base.styl';

  import './init'
  import VueCompositionApi, {ref} from '@vue/composition-api'

  import * as utils from './utils'
  import Vue from 'vue'
  import {mobile_mixin} from "./utils";
  import {useSwipe} from "./utils";

  Vue.use(VueCompositionApi);

  //polyfills for ie11
  require('es6-object-assign').polyfill();
  require('es6-promise').polyfill();
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  //closest
  (function(ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
    ELEMENT.closest = ELEMENT.closest || function closest(selector) {
      if (!this) return null;
      if (this.matches(selector)) return this;
      if (!this.parentElement) {return null}
      else return this.parentElement.closest(selector)
    };
  }(Element.prototype));


  /*use
  * pass(:var1="any_var1" :var2="any_var2")
  *   template(#default='{var1,var2}')
  *     div(:id="var1")
  * */
  Vue.component("pass", {
    inheritAttrs: false,
    render() {
      return this.$scopedSlots.default(this.$attrs);
    }
  });

  //common mixin
  export var common_mixin = {
    data: function() {
      return {
        inMobile: inMobile,
        //window.innerWidth <= 768,
        started: false
      }
    },
    mounted: function () {this.started = true},
    methods: {
      nl2br: function (s) {return utils.nl2br(s)},
      nl2br2: function (s) {return utils.nl2br2(s)},
      nl2p: function (s) {return utils.nl2p(s)},
      bgi: function (s) {return utils.bgi(s)},
      //ref: (val)=> ref(val),
      goal: function (goal,add) {utils.gGoal(goal,add);},
      scrollToBlock: function (name,options) {utils.scrollToBlock(name,options);},
      urlSegment: function (num) {return utils.urlSegment(num)},
      urlSegmentNum: function (num,max,min) {return utils.urlSegmentNum(num,max,min)},
      imgSrc: function(dir, name, mobAdd='_m',png=false) {
        const ext = png ? 'png' : 'jpg';
        return dir+name+(this.inMobile ? mobAdd: '')+'.'+ext
      },
      isIE: function () {return utils.isIE()}
    }
  };

  //scroll directive
  Vue.directive('scroll', {
    inserted: function (el, binding) {
      let lastScrollTop = 0;
      let f = function (e) {
        let scrollTop = window.pageYOffset;
        let options ={scrollTop: scrollTop, lastScrollTop: lastScrollTop};
        lastScrollTop = scrollTop;
        if (binding.value(e, options)) {
          window.removeEventListener('scroll', f)
        }
      };
      window.addEventListener('scroll', f)
    }
  });

  Vue.directive('wheel', {
    inserted: function (el, binding) {
      let f = function (e) {
        if (binding.value(e)) {
          window.removeEventListener('wheel', f)
        }
      };
      window.addEventListener('wheel', f)
    }
  });

  Vue.directive('swipe', {
    inserted: function (el, binding) {
      useSwipe(ref(el),binding.value)
    }
  });

  Vue.mixin(common_mixin);

  export function initVue(content_component, common_component, el) {
//templates for content & common
    let _content =  {
      mixins: [content_component,mobile_mixin],
      beforeCreate: function() {window.main = this;},
    };
    //if (!common_component) common_component = {};
    let _common =  {
      mixins: [common_component,mobile_mixin],
      beforeCreate: function() {window.common = this;},
    };

    if (el === undefined) el = '#main';

    //init app
    new Vue({
      el: el,
      /*template:
        '<section class="main"><div is="main-common" class="main__common" ref="common"/>\n' +
        '<div is="main-content" class="main__content" ref="main"/></section>',*/
      render(h) {
        let components = [h('div',{class:'main__content',is:'main-content'})];
        if (common_component) components.unshift(h('div',{class:'main__common',is:'main-common'}));
        return h('section',{class:'main'}, components);
      },
      name: 'Application',
      data: {
        started: false,
        loaded: false,
        pages: {index: 0, collage: 1, rating: 2, winners: 3},
        pageName: '',
        inPopup: 0
      },
      components: {
        mainCommon: _common,
        mainContent: _content
      },
      beforeCreate: function() {window.app = this;},
      created: function () {this.pageName = content_component.name;},
      computed: {
        pageId: function() {
          let id = this.pages[this.pageName];
          return id !== undefined ? id : -1;
        },
      },
      methods: {}
    });
  }


